import { defineStore } from 'pinia';
import { ref, onUnmounted } from 'vue';

import { EventBus } from './types';

const { DELETE, EDIT } = EventBus.Types;
type SubscriberList = Record<EventBus.Types, EventBus.Callback<any>[]>;

export const useEventBus = defineStore('eventBus', () => {
  const subscriberList = ref<SubscriberList>({
    [DELETE]: [],
    [EDIT]: [],
  });

  const unsubscribe = <T>(event: EventBus.Types, callback: EventBus.Callback<T>) => {
    if (subscriberList.value[event]) {
      subscriberList.value[event] = subscriberList.value[event].filter((cb) => cb !== callback);
    }
  };

  const emit = <T>(event: EventBus.Types, payload: T) => {
    if (subscriberList.value[event]) {
      subscriberList.value[event].forEach((callback) => {
        callback(payload);
      });
    }
  };

  const subscribe = <T>(event: EventBus.Types, callback: EventBus.Callback<T>) => {
    if (!subscriberList.value[event]) {
      subscriberList.value[event] = [];
    }
    subscriberList.value[event].push(callback);

    // Unsubscribe on destroy component
    onUnmounted(() => {
      unsubscribe(event, callback);
    });
  };

  return {
    subscribe,
    unsubscribe,
    emit,
  };
});
